import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {HTTPError, IMessengerConnector} from '../../../types/all.type';
import {BehaviorSubject, debounce, Observable, Subject, timeout} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {AllService} from '../../../services/all.service';
import {VkService} from '../../../pages/page-vk/vk.service';
import {TelegramService} from '../../../pages/page-telegram/telegram.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-profile-username',
  templateUrl: './profile-username.component.html',
  styleUrls: ['./profile-username.component.scss']
})
export class ProfileUsernameComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @Input() Service: IMessengerConnector;
  public editMode$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public checkError$: BehaviorSubject<string> = new BehaviorSubject(undefined);
  public validateStatus$: BehaviorSubject<string> = new BehaviorSubject(undefined);
  Form: UntypedFormGroup;

  get showUserNamePrefix(): boolean {
    return this.Service.arProfile?.username?.indexOf('@') !== -1;
  }

  get usernameExist(): boolean {
    return this.Service.arProfile?.username && this.Service.arProfile.username !== 'None';
  }

  constructor(
    private cd: ChangeDetectorRef,
    public allService: AllService,
  ) {
  }

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      username: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern(/^[a-z0-9_]+$/i)
      ])
    });
    this.allService.setService$.pipe(takeUntil(this.destroy$)).subscribe((type) => {
      this.editMode$.next(false);
    });
  }

  checkUsername(val: string) {
    if (this.Form.invalid) {
      this.checkError$.next(this.Form.get('username').value?.length < 4 ? 'Не менее 4 символов' : 'Допустимые символы a-z, 0-9, _');
      return false;
    }
    this.validateStatus$.next('validating');
    if (this.Service instanceof TelegramService) {
      this.Service.checkUsername(val).pipe(timeout(5000))
        .subscribe((res) => {
          this.checkError$.next(undefined);
          this.validateStatus$.next('success');
        }, error => {
          if (error.name === 'TimeoutError') {
            this.checkError$.next('Ошибка, телеграм аккаунт не отвечает.');
          } else {
            this.checkError$.next(error?.error?.detail?.message || 'Ошибка, сообщите нам.');
          }
          this.validateStatus$.next('error');
        });
    } else {
      alert('Произошла исключительная ошибка, пожалуйста, сообщите нам.');
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setUsername() {
    if (this.Service instanceof TelegramService) {
      const username = this.Form.value.username;
      this.Service.setUsername(username).pipe(timeout(5000))
        .subscribe((res) => {
          this.checkError$.next(undefined);
          this.validateStatus$.next('success');
          this.Service.arProfile.username = username;
          this.editMode$.next(false);
          this.cd.detectChanges();
        }, error => {
          if (error.name === 'TimeoutError') {
            this.checkError$.next('Ошибка, телеграм аккаунт не отвечает.');
          } else {
            this.checkError$.next(error?.error?.detail?.message || 'Ошибка, сообщите нам.');
          }
          this.validateStatus$.next('error');
        });
    } else {
      alert('Произошла исключительная ошибка, пожалуйста, сообщите нам.');
    }
  }
}
